export default {
  'menu.login': 'Login',
  'menu.home': 'Home',
  'menu.welcome': 'Welcome',
  'menu.system': 'System Management',
  'menu.system.user': 'User Management',
  'menu.system.role': 'Role Management',
  'menu.system.menu': 'Menu Management',
  'menu.system.dept': 'Department Management',
  'menu.account': 'Account Management',
  'menu.account.settings': 'Account Settings',
  'menu.account.help': 'Help Center',
  'menu.logout': 'Logout',
  'menu.log': 'Log System',
  'menu.log.login': 'Login Log',
  'menu.log.operate': 'Operate Log',
  'menu.bd': 'BD Management',
  'menu.bd.user': 'User Management',
  'menu.bd.permissions': 'Invite Chain',
  'menu.invitationLink': 'Invitation Link',
  'menu.team': 'Team Management',
  'menu.tradingVolume': 'Trading Volume',
  'menu.teamViewInviteChain': 'View Invite Chain',
  'menu.futures': 'Futures Partner',
  'menu.futures.rebate': 'Rebate Configuration',
  'menu.futures.team': 'Team Management',
  'menu.futures.viewInviteChain': 'View Invite Chain',
  'menu.futures.tradingVolume': 'Trading Volume',
  'menu.futures.teamCommission': 'Team Commission',
  'menu.futures.commissionSummary': 'Commission Summary',
  'menu.futures.commissionDetails': 'Commission Details',
  'menu.futures.myCommission': 'Commission',
  'menu.futures.subordinatePosition': 'Subordinate Position',
  'menu.spot': 'Spot Partner',
  'menu.spot.rebate': 'Rebate Configuration',
  'menu.spot.team': 'Team Management',
  'menu.spot.viewInviteChain': 'View Invite Chain',
  'menu.spot.tradingVolume': 'Trading Volume',
  'menu.spot.teamCommission': 'Team Commission',
  'menu.spot.myCommission': 'Commission',
  'menu.fundRecords': 'Fund Records',
  'menu.fundRecords.rechargeRecord': 'Recharge Record',
  'menu.fundRecords.withdrawRecord': 'Withdrawal Record',
  'menu.fundRecords.transferRecord': 'Transfer Record',
  'menu.dashboardFutures': 'Futures Dashboard',
  'menu.dashboardSpot': 'Spot Dashboard',
  'menu.dashboard': 'Dashboard',
  'menu.activityData': 'Activity Data',
};
